import React from 'react'
import PropTypes from 'prop-types'

import AppointmentFullInfo from 'components/AppointmentFullInfo'
import { Divider } from 'material-ui'

class TeleHealthBottomScreen extends React.Component {

   render() {

      const { appointment, auth } = this.props

      return (
         <div className='TeleHealthBottomScreen'>
            <Divider style={{marginTop: '15px', marginBottom: '15px', marginLeft: '15px', marginRight: '15px'}}/>
            <div style={{ padding: '0px 15px' }}>
               <AppointmentFullInfo
                  appointment={appointment}
                  user={auth}
               />
            </div>
         </div>
      )
   }
}

TeleHealthBottomScreen.propTypes = {
   auth: PropTypes.object.isRequired,
   appointment: PropTypes.object.isRequired,
}

export default TeleHealthBottomScreen


// WEBPACK FOOTER //
// ./src/components/TeleHealth/TeleHealthBottomScreen.js